export type CandidateDefinition = {
  id: string;
  title: string;
  description: string;
  /** ざっくりの用途カテゴリ (informational) */
  pattern: string;
  /** 生の JSX / HTML スニペット (表示用) */
  example: string;
  /** 代表的な参照ファイル。完全網羅は目的ではなく、着手時の足がかり */
  foundIn: string[];
  /** この候補を共通化した場合に置く想定の import パス */
  suggestedComponent: string;
};

export const candidates: CandidateDefinition[] = [
  {
    id: "CAND-0001",
    title: "ステータスバッジ（new / viewed / proposed 等）",
    description:
      "status 文字列を色付きバッジで表示する処理が複数ページで独自実装されている。status → color のマッピングを共通化したい。",
    pattern: "display",
    example: '<span className="badge badge-sm badge-info">new</span>',
    foundIn: [
      "src/routes/matching/MatchingResultsPage/components/MatchingResultsTable.tsx",
      "src/routes/settings/PresetDetailPage/PresetDetailPage.tsx",
      "src/routes/crm/",
    ],
    suggestedComponent: "components/ui/StatusBadge",
  },
  {
    id: "CAND-0002",
    title: "定義リストラベル（dt / セクション小見出し）",
    description:
      "「項目名 : 値」形式の見出し部分が `text-base-content/60 text-xs mb-0.5` のような決まったクラスでバラバラに書かれている。",
    pattern: "display",
    example: '<dt className="text-base-content/60 text-xs mb-0.5">会社名</dt>',
    foundIn: ["src/routes/settings/", "src/routes/crm/"],
    suggestedComponent: "components/ui/DefinitionLabel",
  },
  {
    id: "CAND-0003",
    title: "アウトライン小タグ（badge-outline badge-xs）",
    description:
      "プリセットやタレント詳細のキーワードを並べる際、outline バッジが手書きで大量に並んでいる。",
    pattern: "display",
    example: '<span className="badge badge-outline badge-xs">Go言語</span>',
    foundIn: ["src/routes/settings/PresetDetailPage/", "src/routes/crm/"],
    suggestedComponent: "components/ui/OutlineTag",
  },
  {
    id: "CAND-0004",
    title: "Card + CardBody 手書きパターン",
    description:
      "`card bg-base-100 shadow-sm` + `card-body` の組み合わせが素のままあちこちで書かれている。ContentBoxUI があるがサイズ固定のため使いにくく、素の div で回避されている。",
    pattern: "layout",
    example:
      '<div className="card bg-base-100 shadow-sm"><div className="card-body">…</div></div>',
    foundIn: ["src/routes/"],
    suggestedComponent: "components/ui/Card (+ CardHeader, CardBody)",
  },
  {
    id: "CAND-0005",
    title: "テーブル見出し行（thead + th 共通スタイル）",
    description:
      "一覧ページのテーブル header 行がページごとに手書き。フィルタやソートと合わせて共通化する余地がある。",
    pattern: "display",
    example:
      '<thead className="bg-base-200"><tr><th className="text-xs">…</th></tr></thead>',
    foundIn: ["src/routes/matching/", "src/routes/crm/", "src/routes/admin/"],
    suggestedComponent: "components/ui/Table",
  },
];
